
function n$2(n,t){return void 0===t&&(t=document),t.querySelector(n)}

function t$2(n,t){return void 0===t&&(t=document),[].slice.call(t.querySelectorAll(n))}

function c$1(n,t){return Array.isArray(n)?n.forEach(t):t(n)}

function r$2(n){return function(t,r,e){return c$1(t,function(t){return t[n+"EventListener"](r,e)})}}

function e$2(n,t,c){return r$2("add")(n,t,c),function(){return r$2("remove")(n,t,c)}}

function o$2(n){return function(t){var r=arguments;return c$1(t,function(t){var c;return (c=t.classList)[n].apply(c,[].slice.call(r,1))})}}

function u$1(n){o$2("add").apply(void 0,[n].concat([].slice.call(arguments,1)));}

function i$1(n){o$2("remove").apply(void 0,[n].concat([].slice.call(arguments,1)));}

function l(n){o$2("toggle").apply(void 0,[n].concat([].slice.call(arguments,1)));}

function a$1(n,t){return n.classList.contains(t)}

var n$1=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw "state should be an object";var t;}
var t$1=function(n,t,e,c){return (r=n,r.reduce(function(n,t){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,e){return n.concat(t[e]||[])},[]).map(function(n){return n(e,c)});var r;}
var e$1=a()
var c=e$1.on
var r$1=e$1.emit
var o$1=e$1.hydrate
function a(e){void 0===e&&(e={});var c={};return {getState:function(){return Object.assign({},e)},hydrate:function(r){return n$1(r),Object.assign(e,r),function(){var n=["*"].concat(Object.keys(r));t$1(n,c,e);}},on:function(n,t){return (n=[].concat(n)).map(function(n){return c[n]=(c[n]||[]).concat(t)}),function(){return n.map(function(n){return c[n].splice(c[n].indexOf(t),1)})}},emit:function(r,o,u){var a=("*"===r?[]:["*"]).concat(r);(o="function"==typeof o?o(e):o)&&(n$1(o),Object.assign(e,o),a=a.concat(Object.keys(o))),t$1(a,c,e,u);}}}


export { n$2, t$2, e$2, u$1, i$1, l, a$1, c, r$1, o$1 }
